/* CUSTOM: Teaser menu dropdown (desktop only).
   Opening/closing is done in CSS (:hover / :focus-within). This script only
   adds the things CSS can't do:
     - flips a panel to the other side when it would overflow the viewport
     - keeps aria-expanded in sync
     - Escape closes the open dropdown and returns focus to its trigger
   The side drawer and mobile navigation are not touched. */
(function () {
  var DESKTOP_QUERY = '(min-width: 1200px)';
  var EDGE_GUTTER = 16;

  function isDesktop() {
    return window.matchMedia(DESKTOP_QUERY).matches;
  }

  function childMatch(parent, selector) {
    for (var i = 0; i < parent.children.length; i++) {
      if (parent.children[i].matches(selector)) return parent.children[i];
    }
    return null;
  }

  function setExpanded(item, isOpen) {
    var trigger = childMatch(item, 'a[aria-haspopup]');
    if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  /* Level 2 panel: flip to right-aligned if it runs past the viewport edge. */
  function positionDropdown(item) {
    var panel = childMatch(item, '[data-cc-teaser-dropdown]');
    if (!panel) return;

    panel.classList.remove('cc-teaser__dropdown--flip');
    var rect = panel.getBoundingClientRect();
    if (rect.right > window.innerWidth - EDGE_GUTTER) {
      panel.classList.add('cc-teaser__dropdown--flip');
    }
  }

  /* Level 3 flyout: open to the left when there is no room on the right. */
  function positionFlyout(subitem) {
    var flyout = childMatch(subitem, '[data-cc-teaser-flyout]');
    if (!flyout) return;

    flyout.classList.remove('cc-teaser__flyout--flip');
    var rect = flyout.getBoundingClientRect();
    if (rect.right > window.innerWidth - EDGE_GUTTER) {
      flyout.classList.add('cc-teaser__flyout--flip');
    }
  }

  function initList(list) {
    if (list.dataset.ccTeaserReady === 'true') return;
    list.dataset.ccTeaserReady = 'true';

    var parents = list.querySelectorAll('.cc-teaser__item--parent');
    var subParents = list.querySelectorAll('.cc-teaser__subitem--parent');

    function bind(el, positionFn) {
      var open = function () {
        if (!isDesktop()) return;
        positionFn(el);
        setExpanded(el, true);
      };
      var close = function () {
        el.classList.remove('cc-teaser--closed');
        setExpanded(el, false);
      };

      el.addEventListener('mouseenter', function () {
        el.classList.remove('cc-teaser--closed');
        open();
      });
      el.addEventListener('mouseleave', close);
      el.addEventListener('focusin', open);
      el.addEventListener('focusout', function (e) {
        if (!el.contains(e.relatedTarget)) close();
      });
    }

    for (var i = 0; i < parents.length; i++) bind(parents[i], positionDropdown);
    for (var j = 0; j < subParents.length; j++) bind(subParents[j], positionFlyout);

    /* Escape closes the innermost open panel and puts focus back on its trigger.
       The `cc-teaser--closed` class is what actually keeps it shut: focus stays
       inside the item, so :focus-within alone would re-open it immediately. */
    list.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.keyCode !== 27) return;

      var focused = document.activeElement;
      if (!focused || !list.contains(focused)) return;

      var item =
        focused.closest('.cc-teaser__subitem--parent') ||
        focused.closest('.cc-teaser__item--parent');
      if (!item) return;

      /* Already on the level-3 trigger itself? Escape should close the level-2
         panel instead of re-closing the flyout the caret belongs to. */
      if (
        item.classList.contains('cc-teaser__subitem--parent') &&
        item.classList.contains('cc-teaser--closed')
      ) {
        item.classList.remove('cc-teaser--closed');
        setExpanded(item, false);
        item = focused.closest('.cc-teaser__item--parent');
        if (!item) return;
      }

      e.stopPropagation();
      item.classList.add('cc-teaser--closed');
      setExpanded(item, false);

      var trigger = childMatch(item, 'a[aria-haspopup]');
      if (trigger) trigger.focus();
    });

    /* Panel widths depend on the viewport — recompute flips after a resize. */
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var flipped = list.querySelectorAll(
          '.cc-teaser__dropdown--flip, .cc-teaser__flyout--flip'
        );
        for (var k = 0; k < flipped.length; k++) {
          flipped[k].classList.remove(
            'cc-teaser__dropdown--flip',
            'cc-teaser__flyout--flip'
          );
        }
      }, 150);
    });
  }

  function init() {
    var lists = document.querySelectorAll('.wt-header__nav-teaser__list');
    for (var i = 0; i < lists.length; i++) initList(lists[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor re-renders the header section. */
  document.addEventListener('shopify:section:load', init);
})();
